import styled from 'styled-components'
import { color, size, fontWeight, fontSize } from 'ui/themes/utils'

import { Drawer } from 'vaul'

import I from 'ui/elements/I'

export const Overlay = styled(Drawer.Overlay)`
  position: fixed;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: ${color('Accent2/Controlvariant1')}99;

  z-index: 1000000000;
`

export const Content = styled(Drawer.Content)`
  background-color: ${color('Background/Primary')};

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-flow: column nowrap;

  border-top-left-radius: ${size('borderRadius')};
  border-top-right-radius: ${size('borderRadius')};

  margin-top: 32px;

  z-index: 1000000001;
`

export const Header = styled.div`
  position: relative;

  padding: ${size('padding')};
  padding-right: ${size('padding', 'lgplus')};

  border-bottom: ${size('borderWidth')} solid ${color('Misc/Divider')};

  container-type: inline-size;
`

export const Close = styled.button`
  /* Reset button default styles */
  appearance: none;
  background: transparent;
  border: none;
  padding: 0;

  position: absolute;

  top: ${size('padding', 'md')};
  right: ${size('padding', 'md')};

  ${I} {
    opacity: 0.6;

    font-weight: ${fontWeight('bold')};
    font-size: ${fontSize('lg')};
  }
`

export const Body = styled.div`
  flex: 1;

  overflow-y: auto;
`

export const Title = styled(Drawer.Title)`
  margin: 0;
  margin-bottom: ${size('margin', 'sm')};

  color: ${color('Text/Primary')};

  font-family: ${(props) => props.theme.font.body};
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('semibold')};

  &:empty {
    visibility: hidden;
  }
`
